import { useContext } from "react";
import { sessionStore } from "../contexts/SessionContext";

export const useVersion = () => {
  const {
    session: { version },
  } = useContext(sessionStore);
  return version;
};
